/// <amd-module name="SuiteCommerce.ShippingBar.Main"/>
define("SuiteCommerce.ShippingBar.Main", ["require", "exports", "SuiteCommerce.ShippingBar.Common.Configuration", "SuiteCommerce.ShippingBar.PDPShippingBar.View", "SuiteCommerce.ShippingBar.HeaderShippingBar.View", "SuiteCommerce.ShippingBar.CartShippingBar.View", "SuiteCommerce.ShippingBar.Main.Model", "SuiteCommerce.ShippingBar.Configuration.Helper", "SuiteCommerce.ShippingBar.Common.Instrumentation.Helper", "SuiteCommerce.ShippingBar.Main.Configuration"], function (require, exports, Configuration_1, PDPShippingBar_View_1, HeaderShippingBar_View_1, CartShippingBar_View_1, Main_Model_1, Configuration_Helper_1, Instrumentation_Helper_1, Main_Configuration_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            Instrumentation_Helper_1.InstrumentationHelper.initializeInstrumentation(container);
            Configuration_1.Configuration.environment = container.getComponent('Environment');
            try {
                /** @type {ProductDetailsComponent} */
                var layout = container.getComponent('Layout');
                var pdp = container.getComponent('PDP');
                var cart = container.getComponent('Cart');
                var goalType = 'Amount';
                var barUrlLink = Main_Configuration_1.MainConfiguration.barUrlLink();
                var barUrlLinkAlt1 = Main_Configuration_1.MainConfiguration.barUrlLinkAlt1();
                var barUrlLinkAlt2 = Main_Configuration_1.MainConfiguration.barUrlLinkAlt2();
                var showHeaderBar = Main_Configuration_1.MainConfiguration.showHeaderBar();
                var headerPosition = Main_Configuration_1.MainConfiguration.shippingBarHeaderPosition();
                var headerInitialMessage = Main_Configuration_1.MainConfiguration.headerInitialMessage();
                var headerMessageAlt1 = Main_Configuration_1.MainConfiguration.headerMessageAlt1();
                var headerMessageAlt2 = Main_Configuration_1.MainConfiguration.headerMessageAlt2();
                var headerProgressMessage = Main_Configuration_1.MainConfiguration.headerProgressMessage();
                var headerCongratsMessage = Main_Configuration_1.MainConfiguration.headerCongratsMessage();
                var shippingBarHeaderView_1;
                var isFloating = headerPosition === 'Float Top';
                var showDetailBanner_1 = Main_Configuration_1.MainConfiguration.showDetailBanner();
                var pdpProgressMessage = Main_Configuration_1.MainConfiguration.pdpProgressMessage();
                var itemQualifyMessage = Main_Configuration_1.MainConfiguration.itemQualifyMessage();
                var showCartBanner = Main_Configuration_1.MainConfiguration.showCartBanner();
                var cartInitialMessage = Main_Configuration_1.MainConfiguration.cartInitialMessage();
                var cartProgressMessage = Main_Configuration_1.MainConfiguration.cartProgressMessage();
                var cartCongratsMessage = Main_Configuration_1.MainConfiguration.cartCongratsMessage();
                var model_1 = new Main_Model_1.ShippingBarModel({
                    cart: cart,
                    pdp: pdp,
                    goalType: goalType,
                    barUrlLink: barUrlLink,
                    barUrlLinkAlt1: barUrlLinkAlt1,
                    barUrlLinkAlt2: barUrlLinkAlt2,
                    headerInitialMessage: headerInitialMessage,
                    headerProgressMessage: headerProgressMessage,
                    pdpProgressMessage: pdpProgressMessage,
                    cartInitialMessage: cartInitialMessage,
                    cartProgressMessage: cartProgressMessage,
                    cartCongratsMessage: cartCongratsMessage,
                    itemQualifyMessage: itemQualifyMessage,
                    headerCongratsMessage: headerCongratsMessage,
                    headerMessageAlt1: headerMessageAlt1,
                    headerMessageAlt2: headerMessageAlt2,
                });
                if (pdp && showDetailBanner_1) {
                    pdp.addChildViews('ProductDetails.Full.View', {
                        Quantity: {
                            FreeShippingBar: {
                                childViewIndex: 10,
                                childViewConstructor: function () {
                                    return new PDPShippingBar_View_1.ShippingBarPDPView({
                                        model: model_1,
                                        showDetailBanner: showDetailBanner_1,
                                    });
                                },
                            },
                        },
                    });
                }
                if (layout && showHeaderBar) {
                    shippingBarHeaderView_1 = new HeaderShippingBar_View_1.ShippingBarHeaderView({
                        model: model_1,
                        container: container,
                        isFloating: isFloating,
                    });
                    if (headerPosition === 'Below Header') {
                        layout.addChildView('Header', function () {
                            return shippingBarHeaderView_1;
                        });
                    }
                    else {
                        layout.addChildView('Message.Placeholder', function () {
                            return shippingBarHeaderView_1;
                        });
                    }
                }
                if (cart && showCartBanner) {
                    cart.addChildView('cms:cart_detailed_cms_area_1', function () {
                        return new CartShippingBar_View_1.ShippingBarCartView({
                            model: model_1,
                            device: 'desktop',
                        });
                    });
                    cart.addChildView('Quick.Order', function () {
                        return new CartShippingBar_View_1.ShippingBarCartView({
                            model: model_1,
                            device: 'mobile',
                        });
                    });
                }
                Configuration_Helper_1.ConfigurationHelper.logCurrencyAndAmount();
                Configuration_Helper_1.ConfigurationHelper.logHiddenCartBar();
                Configuration_Helper_1.ConfigurationHelper.logHiddenDetailBar();
            }
            catch (err) {
                console.log(err);
            }
        },
    };
});
